module.exports = {"svg":{"$":{"viewBox":"0 0 255 255","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"path":[{"$":{"d":"M127.5,255 C57.1551724,255 0,197.844828 0,127.5 C0,57.1551724 57.1551724,0 127.5,0 L127.5,12.8514589 C64.2572944,12.8514589 12.8514589,64.2572944 12.8514589,127.5 C12.8514589,190.742706 64.2572944,242.148541 127.5,242.148541 C190.742706,242.148541 242.148541,190.742706 242.148541,127.5 L255,127.5 C255,197.844828 197.844828,255 127.5,255 Z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/icon-loader.svg
// module id = 496
// module chunks = 0